module.exports = {
  siteTitle: 'Daqi (Jen) Chen | Software Engineer & Paper Artist',
  siteDescription:
    'Jen Chen is an aspiring software engineer with experiences in frontend development, data modeling & visualization, healthtech consulting, and advanced origami : )',
  siteKeywords:
    'Daqi Chen, Daqi, Chen, Jen, Daqi (Jen) Chen, Jen Chen, Jen, computer science, statistics, data scientist, software engineer, front-end engineer, web developer, javascript, R, java, C, python, unc chapel hill',
  siteUrl: 'https://daqichen.github.io',
  image: '/og.png',
  email: 'daqichen@alumni.unc.edu',
  instagramHandle: '@jenniferchen_d',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/daqichen',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/daqi-jennifer-chen',
    },
    {
      name: 'Tableau',
      url: 'https://public.tableau.com/profile/daqi.chen',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/dacheese_origami',
    },
    // {
    //   name: 'Twitter',
    //   url: 'https://twitter.com/chen_daqi',
    // },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
